export default __webpack_public_path__ + "5efc795.png";